/**
 * DeductionTable Component
 * 라이더 일차감 정보 테이블
 */
import React from 'react';
import { RiderDeductionInfo } from '../types/riderInfoDetail.types';
import {
    DEDUCTION_TABLE_COLUMNS,
    DEDUCTION_COLUMN_COUNT,
    formatCurrency
} from '../lib/riderInfoDetailHelpers';

interface DeductionTableProps {
    deductions: RiderDeductionInfo[];
}

const DeductionTable: React.FC<DeductionTableProps> = ({ deductions }) => {
    return (
        <div className="section-margin">
            <h3 className="section-title">일차감 정보</h3>
            <div className="deduction-container">
                <table className="deduction-table">
                    <thead>
                        <tr>
                            {DEDUCTION_TABLE_COLUMNS.map((column) => (
                                <th key={column}>{column}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {deductions.length === 0 ? (
                            <tr>
                                <td colSpan={DEDUCTION_COLUMN_COUNT} className="empty-deduction-message">
                                    일차감 정보가 없습니다.
                                </td>
                            </tr>
                        ) : (
                            deductions.map((deduction, index) => (
                                <tr key={deduction.id}>
                                    <td>{index + 1}</td>
                                    <td>{deduction.name}</td>
                                    <td>{formatCurrency(deduction.amount)}</td>
                                    <td>{deduction.startDate}</td>
                                    <td>{deduction.endDate}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DeductionTable;
